import { onTrackEvent } from './onTrackEvent';

/**
 * @param {number} count
 */
export const onCartCountUpdate = (count) => {
  document.querySelectorAll('mini-cart-button').forEach((el) => {
    el.count = count.toString();
  });
};

const onePageStoreEvent = {
  onCartCountUpdate,
  onTrackEvent,
};

export default onePageStoreEvent;
